export default __webpack_public_path__ + "static/RR_Custom-TC-a626c8f300a99dd4c54bdf84a6512544.ttf";